export default class ConvenioService {
  constructor(resource) {
    this._resource = resource;
  }

  getConvenioValidoByInscricao(inscricao) {
    return this._resource
      .get(`secretaria/convenio`, { params: { inscricao } })
      .then(
        res => res.json(),
        err => {
          console.log(err);
          throw new Error(err.body);
        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/domain/secretaria/ConvenioService.js